import { all } from "redux-saga/effects";

//public
import AuthenticationSaga from "./authentication/saga";
import settingsSaga from "./settings/saga";
import sectionSaga from "./section/saga";
import subscribersSaga from "./subscribers/saga";
import socialTypesSaga from "./socialTypes/saga";
import socialsSaga from "./socials/saga";
import blogsSaga from "./blogs/saga";
import blogCategoriesSaga from "./blogCategories/saga";
import contactUsSaga from "./contactUs/saga";
import servicesSaga from "./ourServices/saga";
import worksSaga from "./ourWorks/saga";

export default function* rootSaga() {
  yield all([
    AuthenticationSaga(),
    settingsSaga(),
    sectionSaga(),
    servicesSaga(),
    worksSaga(),
    subscribersSaga(),
    socialTypesSaga(),
    socialsSaga(),
    blogsSaga(),
    blogCategoriesSaga(),
    contactUsSaga(),
  ]);
}
